import Vue from 'vue';
import App from './app.vue'

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
});

